import React from 'react';

const LazyMyTeam = React.lazy(() =>
  import(/* webpackChunkName: "MyTeam" */ './myTeam')
);

const MyTeam = (props: Record<string, any>) => (
  <React.Suspense fallback={<h1>Loading...</h1>}>
    <LazyMyTeam {...props} />
  </React.Suspense>
);

export default MyTeam